import { useStableCallback } from '@ipfabric/ui-components/hooks/useStableCallback';
import { useNavigate } from 'react-router-dom';
import { useApiScopeRequirementMet } from 'utils/permissions/useApiScopeRequirementMet';
import {
  DISCOVERY_DATA_ENRICHMENT_LINK_STATE_KEY,
  DISCOVERY_DATA_ENRICHMENT_PATH,
  type DiscoveryDataEnrichmentLink,
} from './discoveryDataEnrichmentLink';

export type OpenDiscoveryDataEnrichment = (
  link: DiscoveryDataEnrichmentLink,
) => void;

/**
 * Returns `undefined` when the user is not allowed to open the Discovery data
 * enrichment page, so callers can render plain text instead of a dead link.
 */
export const useOpenDiscoveryDataEnrichment = ():
  | OpenDiscoveryDataEnrichment
  | undefined => {
  const navigate = useNavigate();
  const apiScopeRequirementMet = useApiScopeRequirementMet();

  const open = useStableCallback((link: DiscoveryDataEnrichmentLink) => {
    navigate(DISCOVERY_DATA_ENRICHMENT_PATH, {
      state: { [DISCOVERY_DATA_ENRICHMENT_LINK_STATE_KEY]: link },
    });
  });

  return apiScopeRequirementMet({ method: 'GET', path: '/settings' })
    ? open
    : undefined;
};
